





















































import { EmailConfiguracao } from "@/services/email.service";
import { required, validEmail } from "@/shared/validators";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

class EmailConfigForm implements EmailConfiguracao {
  nmRemetente = "Empresária Online";
  emailRemetente = "marketing@empresariaonline.com.br";
  nmResponderPara = "Empresária Online";
  emailResponderPara = "suporte@empresariaonline.com.br";
  assunto = "";
}

@Component({})
export default class EmailConfig extends Vue {
  //Atributos
  rules = {
    nmRemetente: [required()],
    emailRemetente: [required(), validEmail()],
    emailResponderPara: [validEmail()],
    assunto: [required()],
  };

  data: EmailConfiguracao = new EmailConfigForm();

  //Props
  @Prop() readonly value!: EmailConfiguracao;

  mounted() {
    this.onChange(this.value);
  }

  @Watch("value")
  onChange(val: EmailConfiguracao | null | undefined) {
    if (val) this.data = val;
    this.emitir();
  }

  emitir() {
    this.$emit("input", this.data);
  }

  reset(){
    this.onChange(new EmailConfigForm());
  }
}
